import PageHeader from "core/components/Header/PageHeader";
import { useScrollToTop } from "core/hooks/useScrollToTop";
import AppLayout from "core/layouts/AppLayout";
import BottomNavigation from "core/layouts/BottomNavigation";
import { _t } from "core/language";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useGetCountCart, useGetListCart, useUpdateCart, useUpdateCartList } from "../hooks";
import InfiniteScroll from "react-infinite-scroll-component";
import GroupAction, { ActionType } from "core/components/GroupAction";
import { ActionTypeEnumCart } from "core/config/constant";
import LoadingCart from "../components/LoadingCart";
import EmptyData from "core/components/EmptyData/EmptyData";
import { removeItemByIdInArray } from "core/utils/helper";
import { CoupangDesciption } from "core/components/Coupang";
import CoupangAds from "core/components/Coupang/CoupangAds";
import { LanguageCode } from "core/constants";

const CartPage = () => {
  useScrollToTop();

  const location = useLocation();
  const queryString = location?.search;
  const params = new URLSearchParams(queryString);
  const queryParams: any = {};

  params.forEach((value, key) => {
    queryParams[key] = value;
  });

  const [param,setParam] = useState<any>({
    order_by: "created_at",
    order_dir: "desc",
    page: 1,
    page_size: 10,
  });

  const { loading, dataList, lastPage, loadMore } = useGetListCart(param);
  const { updateCart } = useUpdateCart();
  const { countCart } = useGetCountCart();
  const [carts, setCarts] = useState<any>([])

  useEffect(() => {
   
    const viewportHeight = window.innerHeight;
    if(viewportHeight > 700) {
      setParam({...param, page_size:20})
    }
    
  },[])
  
  useEffect(() => {
    setCarts(dataList)
  },[dataList])

  useUpdateCartList(carts)

  const handleRemoveCart = (e: any, data: any) => {
    switch (e) {
      case ActionType.REMOVE:
        // eslint-disable-next-line no-case-declarations
        const dataRequest = {
          ids: [data?.id],
          action: ActionTypeEnumCart.REMOVE,
        };
        updateCart(dataRequest);
        break;
      default:
        break;
    }
    const updatedList = removeItemByIdInArray(carts, data?.id);
    setCarts(updatedList)
  };
  const handleFetchMore = () => {
    if (loading) {
      return
    }
    if(lastPage > param?.page && !loading){
      loadMore()
    }
  }

  const pd = (window as any)._APP_LANG === "ko" ? '!pb-[140px]' : 'pb-[70px]';
  return (
    <AppLayout className={` no-scrollbar ${pd}`}>
      <PageHeader
        className="fixed w-full z-[200] bg-white"
        title={_t("carts.LabelCarts")}
      />
      <div className="px-4 pt-[43px]" />
      <div className="px-4 mt-[30px] no-scrollbar pb-24">
        <h3 className="text-[13px] mb-[14px]">
          {_t("carts.Material")}{" "}
          <label className="text-[13px] text-[#ff6741]">{countCart}</label>
        </h3>
        <div className=" rounded-lg no-scrollbar">
          <div className="no-scrollbar" id="main-list">
            <InfiniteScroll
              dataLength={carts.length}
              next={handleFetchMore}
              hasMore={!!carts.length}
              loader={lastPage > param?.page ? <LoadingCart /> : null}
              className="!overflow-x-hidden no-scrollbar"
            >
              {carts?.map((ingredient: any, key: number) => (
                <div
                  className="flex justify-between items-center mb-[14px]"
                  key={key}
                >
                  <label className="text-sm font-medium">
                    {ingredient.name}
                  </label>
                  <GroupAction
                    isCart={false}
                    ingredient_id={ingredient.id}
                    isRemove
                    handleClickIcon={(e) => handleRemoveCart(e, ingredient)}
                  />
                </div>
              ))}
            </InfiniteScroll>
          </div>
        </div>
        {!carts.length && loading && <LoadingCart />}
        {carts.length === 0 && !loading && (
          <EmptyData message={_t("carts.nodata")} />
        )}
      </div>
      <CoupangDesciption className={`fixed bottom-0 pb-24 px-4 bg-white ${(window as any)._APP_LANG !== LanguageCode.ko ? '' : ' mb-[50px]'}`} />
      <CoupangAds />
      <BottomNavigation activeIndex={0} />
    </AppLayout>
  );
};

export default CartPage;
